<template>
    <div class="main-body">
        <h2>{{ $strings('cpsite/trx/title') }}</h2>
        <div class="action-bar">
            <el-form :inline="true" :model="filter" class="demo-form-inline">
                <el-form-item label="">
                    <el-select v-model="filter.cp_app_id" size="small" class="max-width-160" :disabled="loading"
                               clearable>
                        <el-option v-for="(item, idx) in options.apps" :key="idx" :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <el-date-picker
                        v-model="filter.date"
                        class="max-width-120"
                        type="date"
                        size="small"
                        format="MM-dd"
                        value-format="yyyy-MM-dd"
                        placeholder="Pick Date">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onFilter" size="small">{{ $strings('word/query') }}</el-button>
                    <el-button @click="onReset" size="small">{{ $strings('word/reset') }}</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div>
            <el-table
                v-loading="tableLoading"
                border
                :data="tableData"
                style="width: 100%">
                <el-table-column type="expand" label="∷">
                    <template slot-scope="scope">
                        <ul>
                            <li>{{ $strings('word/message_id') }}: {{ scope.row.message_id }}</li>
                            <li>{{ $strings('word/cp_app_id') }}: {{ scope.row.cp_app_id }}</li>
                        </ul>
                    </template>
                </el-table-column>
                <el-table-column prop="cp_data" :label="$strings('word/cp_data')"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="msisdn" :label="$strings('word/msisdn')" width="120"></el-table-column>
                <el-table-column prop="country" :label="$strings('word/country')"></el-table-column>
                <el-table-column prop="amount" :label="$strings('word/amount')"></el-table-column>
                <el-table-column prop="status_code" :label="$strings('word/status_code')"></el-table-column>
                <el-table-column prop="is_flash" :label="$strings('word/is_flash')">
                    <template slot-scope="scope">{{ scope.row.is_flash > 0 ? 'Y' : 'N' }}</template>
                </el-table-column>
                <el-table-column prop="is_unicode" :label="$strings('word/is_unicode')">
                    <template slot-scope="scope">{{ scope.row.is_unicode > 0 ? 'Y' : 'N' }}</template>
                </el-table-column>
                <el-table-column prop="ct_time" :label="$strings('word/ct_time')" width="200">
                    <template slot-scope="scope">
                        {{ convertUnixToDate(scope.row.ct_time) }}
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import {GetItem} from "@/utils/storage";
import {STORAGE_KEY_LOGIN_TZ} from "@/config/config";
import {DefaultDate, UnixToDateFull} from "@/utils/time";
import {CpSitAppRead, CpSiteTrxRead} from "@/api/cpsite/api";

export default {
    name: "cpsite-trx",
    data() {
        return {
            loading: false,
            tableLoading: true,
            tableData: [],
            filter: {tz: 0, date: '', cp_app_id: ''},
            pagination: {total: 0, size: 20, page: 1},
            options: {apps: {}}
        }
    },
    created() {
        this.prepare();
        this.refresh();
    },
    methods: {
        onFilter() {
            this.refresh();
        },
        onReset() {
            this.filter.cp_app_id = '';
            this.refresh();
        },
        convertUnixToDate(ts) {
            let tz = parseInt(GetItem(STORAGE_KEY_LOGIN_TZ))
            return UnixToDateFull(ts, tz);
        },
        prepare() {
            this.filter.tz = 1 * GetItem(STORAGE_KEY_LOGIN_TZ);
            this.filter.date = DefaultDate();
            this.loading = true;
            CpSitAppRead({page: 1, size: 100}).then((resp) => {
                this.options.apps = [];
                if (resp.data.data.total > 0) {
                    this.options.apps.push({value: '', label: this.$strings('word/all_apps')});
                    resp.data.data.rows.forEach((item) => {
                        this.options.apps.push({value: item.app_id, label: item.app_name});
                    })
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        refresh() {
            this.tableLoading = true;
            CpSiteTrxRead(this.filter).then((resp) => {
                if (resp.data.data.count > 0) {
                    this.pagination.total = resp.data.data.count;
                    this.tableData = resp.data.data.rows;
                } else {
                    this.tableData = [];
                }
            }).finally(() => {
                this.tableLoading = false;
            });
        }
    }
}
</script>

<style scoped lang="scss">
.action-bar {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}
</style>